function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".quotes-cls-1{fill:#fff;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Calque_2",
  "data-name": "Calque 2"
}, React.createElement("g", {
  id: "Contenu"
}, React.createElement("path", {
  className: "quotes-cls-1",
  d: "M10.47,15.34v-1.8a4.91,4.91,0,0,1-4.7-3.49A5.05,5.05,0,1,0,0,4.88H0v.18c0,.06,0,.12,0,.18A10.46,10.46,0,0,0,10.47,15.34Z"
}), React.createElement("path", {
  className: "quotes-cls-1",
  d: "M23.58,15.34v-1.8a4.91,4.91,0,0,1-4.7-3.49,5.05,5.05,0,1,0-5.76-5.17h0v.18a1.09,1.09,0,0,0,0,.18A10.46,10.46,0,0,0,23.58,15.34Z"
})));

var SvgQuotes = function SvgQuotes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 23.58 15.34",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgQuotes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quotes.a3dda6df.svg";
export { ForwardRef as ReactComponent };